export default {
  referrals(state) {
    return state.referrals;
  },
};
